import React from "react";
import "./reviews.scss";
import {
  AppBar,
  Avatar,
  Box,
  Button,
  Dialog,
  Grid,
  IconButton,
  LinearProgress,
  Rating,
  Skeleton,
  Toolbar,
  useMediaQuery,
} from "@mui/material";
import dateformat from "dateformat";
import productRatingStore from "../../stores/productRatingStore";
import usersStore from "../../stores/usersStore";

// icon
import StarRoundedIcon from "@mui/icons-material/StarRounded";
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";
import VerifiedRoundedIcon from "@mui/icons-material/VerifiedRounded";
import ThumbUpOutlinedIcon from "@mui/icons-material/ThumbUpOutlined";
import ThumbDownOutlinedIcon from "@mui/icons-material/ThumbDownOutlined";
import userImg from "../../assets/demo/user1.jpg";
import { useState } from "react";
import { useEffect } from "react";

// Images
import male from "../../assets/avatar_male.jpg";
import female from "../../assets/avatar_female.jpg";
import unknown from "../../assets/avatar_unknown.jpg";
import ReviewCard from "./reviewCard/ReviewCard";
import CreateReviewModal from "./createReviewModal/CreateReviewModal";

const Reviews = ({ productID }) => {
  const ProductRatingStore = productRatingStore();
  const UsersStore = usersStore();
  const maxWidth_600 = useMediaQuery("(max-width:600px)");

  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [totalReview, setTotalReview] = useState(0);
  const [productReview, setProductReview] = useState([]);
  const [averageRating, setAverageRating] = useState(0);

  const [particularRating, setParticularRating] = useState([
    { id: 1, name: "5 Star", value: 0, reviewCount: "0" },
    { id: 2, name: "4 Star", value: 0, reviewCount: "0" },
    { id: 3, name: "3 Star", value: 0, reviewCount: "0" },
    { id: 4, name: "2 Star", value: 0, reviewCount: "0" },
    { id: 5, name: "1 Star", value: 0, reviewCount: "0" },
  ]);

  useEffect(() => {
    if (ProductRatingStore.allRating) {
      let totalR = 0;
      let averageR = 0;

      let fiveStarR = 0;
      let fourStarR = 0;
      let threeStarR = 0;
      let twoStarR = 0;
      let oneStarR = 0;

      let productRatingReview = [];

      ProductRatingStore.allRating
        .sort((a, b) => {
          return new Date(b.created_at) - new Date(a.created_at);
        })
        .map((item) => {
          if (productID === item.productID) {
            totalR++;
            averageR = averageR + item.rating;
            productRatingReview = [...productRatingReview, item];
            if (item.rating === 5) {
              fiveStarR++;
            }
            if (item.rating === 4) {
              fourStarR++;
            }
            if (item.rating === 3) {
              threeStarR++;
            }
            if (item.rating === 2) {
              twoStarR++;
            }
            if (item.rating === 1) {
              oneStarR++;
            }
          }
        });
      setProductReview(productRatingReview);
      setTotalReview(totalR);
      if (totalR !== 0) {
        setAverageRating(averageR / totalR);

        const fiveStarB = (fiveStarR / totalR) * 100;
        const fourStarB = (fourStarR / totalR) * 100;
        const threeStarB = (threeStarR / totalR) * 100;
        const twoStarB = (twoStarR / totalR) * 100;
        const oneStarB = (oneStarR / totalR) * 100;

        setParticularRating([
          { id: 1, name: "5 Star", value: fiveStarB, reviewCount: fiveStarR },
          { id: 2, name: "4 Star", value: fourStarB, reviewCount: fourStarR },
          { id: 3, name: "3 Star", value: threeStarB, reviewCount: threeStarR },
          { id: 4, name: "2 Star", value: twoStarB, reviewCount: twoStarR },
          { id: 5, name: "1 Star", value: oneStarB, reviewCount: oneStarR },
        ]);
      } else {
        setAverageRating(0);
        setParticularRating([
          { id: 1, name: "5 Star", value: 0, reviewCount: "0" },
          { id: 2, name: "4 Star", value: 0, reviewCount: "0" },
          { id: 3, name: "3 Star", value: 0, reviewCount: "0" },
          { id: 4, name: "2 Star", value: 0, reviewCount: "0" },
          { id: 5, name: "1 Star", value: 0, reviewCount: "0" },
        ]);
      }
    }
  }, [productID, ProductRatingStore.allRating]);

  return (
    <Grid container className="reviews">
      <Grid item container className="overview">
        <Grid
          item
          xs={12}
          md={4}
          sx={{ border: "1px solid hsl(220, 10%, 94%)" }}
          className="average-rating"
        >
          <h3>Average rating</h3>
          <h1>{averageRating.toFixed(1)}/5</h1>
          <Rating
            name="read-only"
            value={parseInt(averageRating.toFixed(1))}
            readOnly
            precision={0.1}
            sx={{ fontSize: "23px" }}
            icon={<StarRoundedIcon fontSize="inherit" />}
            emptyIcon={<StarRoundedIcon fontSize="inherit" />}
          />
          <p>
            (
            {totalReview > 999
              ? (totalReview / 1000).toFixed(2) + "k"
              : totalReview}{" "}
            reviews)
          </p>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
          sx={{ border: "1px solid hsl(220, 10%, 94%)" }}
          className="particular-rating"
        >
          {particularRating &&
            particularRating.map((item) => (
              <Box className="single-rating" key={item.id}>
                <p className="star">{item.name}</p>
                <LinearProgress
                  variant="determinate"
                  value={item.value}
                  className="linear-progress"
                />
                <p>{item.reviewCount}</p>
              </Box>
            ))}
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
          sx={{ border: "1px solid hsl(220, 10%, 94%)" }}
          className="write-your-review"
        >
          <CreateReviewModal productID={productID} />
        </Grid>
      </Grid>
      <Grid item container className="reviews-container">
        {ProductRatingStore.isLoading || UsersStore.isLoading
          ? "Loading..."
          : productReview
              .slice(0, 4)
              .reverse()
              .map((review) => {
                let username = "";
                let gender = "";
                if (review.productID === productID) {
                  if (review.userID) {
                    const user = UsersStore.allUser.find(
                      (user) => review.userID === user._id,
                    );
                    username = user.firstName + " " + user.lastName;
                    gender = user.gender;
                  } else {
                    username = review.username;
                  }
                  return (
                    <ReviewCard
                      key={review._id}
                      username={username}
                      gender={gender}
                      review={review}
                    />
                  );
                }
              })}
        {totalReview > 4 && (
          <Button
            sx={{ m: 1, color: "var(--blackColor)", width: "100%" }}
            onClick={handleClickOpen}
          >
            View All
          </Button>
        )}
      </Grid>
      <Dialog
        fullScreen={maxWidth_600 ? true : false}
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth="lg"
        // TransitionComponent={Transition}
      >
        <AppBar sx={{ position: "sticky" }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <Grid item container className="reviews-container">
          {ProductRatingStore.isLoading || UsersStore.isLoading
            ? "Loading..."
            : productReview
                .slice(0)
                .reverse()
                .map((review) => {
                  let username = "";
                  let gender = "";
                  if (review.productID === productID) {
                    if (review.userID) {
                      const user = UsersStore.allUser.find(
                        (user) => review.userID === user._id,
                      );
                      username = user.firstName + " " + user.lastName;
                      gender = user.gender;
                    } else {
                      username = review.username;
                    }

                    return (
                      <ReviewCard
                        key={review._id}
                        username={username}
                        gender={gender}
                        review={review}
                      />
                    );
                  }
                })}
        </Grid>
      </Dialog>
    </Grid>
  );
};

export default Reviews;
